import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { styled, Box } from '@mui/material';
import Iconify from '../../Iconify';

const OuterBox = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '450px',
}));

const CustIcon = styled(Iconify)(() => ({
  color: 'rgba(255, 255, 255, 0.7)',
  fontSize: '2.5rem',
  padding: '10px 10px 0 0',
}));

X3DViewer.propTypes = {
  preview: PropTypes.any,
};
async function getModelFileContent(fileUrl) {
  try {
    const response = await fetch(fileUrl);
    if (response.ok) {
      const x3dContent = await response.text();
      return x3dContent;
    }
    throw new Error('Failed to fetch the model file');
  } catch (error) {
    console.error('Error getting model file content:', error);
    return null;
  }
}

export default function X3DViewer({ preview }) {
  const [x3dContentURL, setX3dContentURL] = useState(null); // State to store the X3D content URL

  useEffect(() => {
    if (preview?.model?.fileUrl) {
      const lastSlashIndex = preview.model.fileUrl.lastIndexOf('/'); // Finding the last occurrence of '/'
      const baseUrl = preview.model.fileUrl.substring(0, lastSlashIndex + 1); // Extracting the base URL

      getModelFileContent(preview.model.fileUrl).then((content) => {
        if (content) {
          const up = content.replace(/<ImageTexture url="([^"]*)"/g, `<ImageTexture url='"${baseUrl}$1"'`);
          const updatedContent = up.replaceAll('&quot;', '');
          // Convert the X3D content string to a Blob
          const x3dBlob = new Blob([updatedContent], { type: 'model/x3d+xml' });

          // Create a URL for the Blob object
          const x3dBlobURL = URL.createObjectURL(x3dBlob);

          setX3dContentURL(x3dBlobURL); // Set the URL representing the X3D content
        }
      });
    }
  }, [preview]);

  useEffect(
    () => () => {
      if (x3dContentURL) {
        URL.revokeObjectURL(x3dContentURL);
      }
    },
    [x3dContentURL]
  );
  return (
    <OuterBox className="preview-box">
      {x3dContentURL ? (
        <div style={{ position: 'relative', width: '100%', height: '100%', zIndex: 1000 }}>
          <x3d-canvas
            // eslint-disable-next-line no-undef
            src={x3dContentURL}
            style={{ width: '100%', height: '100%' }}
          />

          <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 2000 }}>
            {/* <Iconify icon="mdi:rotate-3d" color="#ffc425" width={44} height={44} /> */}
            <CustIcon icon="material-symbols:3d-rotation" />
          </div>
        </div>
      ) : (
        <div className="preview-box">
          <span className="preview-loading">
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center', // Add this line to align the content vertically

                textAlign: 'center',
                lineHeight: '100%',
              }}
            >
              <Iconify icon="eos-icons:three-dots-loading" color="#ffc425" width={44} height={44} />
            </Box>
          </span>

          {/* <span className="not-available">{translate('preview.noPreview')}</span> */}
        </div>
      )}
    </OuterBox>
  );
}
